import { Application } from '../../../../../../../../types/api';
import {
  AdditionalDocumentsValidation,
  LeaseOfTheSystemPropertyValidation,
  OfftakerPPAorLeaseAgreementValidation,
  ProofOfOfftakerCreditworthinessValidation,
  OffTakerLeaseOrProofOfOwnershipValidation,
  OffTakerUtilityBillValidation,
  PpaLeaseFinancialProjectionsValidation,
  ApprovalForCommunitySolarDeliveryValidation,
  CommunitySolarFinancialProjectionsValidation,
  SubscriberManagementCompanyContractValidation,
  PrincipalsValidation,
} from '../../../../../validations/required_documents';

import {
  CurrentOccupantLedgerValidation,
  PriorYearBudgetsValidation,
  NonProfitBoardResolutionValidation,
  ReligiousOrganizationAttendanceValidation,
  NonProfitBylawsCopyValidation,
  PropertyCompanyRentRollValidation,
  PropertyCompanyUploadRentRollOrProvideTenantInfoValidation,
  PropertyCompanyTenantNameValidation,
  PropertyCompanyTenantMoveInYearValidation,
  PropertyCompanyTenantRenewalYearValidation,
  PropertyCompanyTenantRenewalLengthValidation,
  PropertyCompanyTenantMonthlyRentPaymentValidation,
  PropertyCompanyTenantPaymentsSatisfactoryValidation,
  PgMortgageStatementValidation,
  MeetingMinutesValidation,
  SystemPropertyHasRelatedTenantsValidation,
  PropertyTenantWillingToBeCommercialGuarantorValidation,
  TaxReturnForLeasingPropCoValidation,
} from './validations/required_documents';

import ReserveStudyValidation from './validations/required_documents/ReserveStudyValidation';
import DelinquencyReportValidation from './validations/required_documents/DelinquencyReportValidation';

import {
  BankStatementsLastMonthValidation,
  BankStatements2MonthValidation,
  BankStatements3MonthValidation,
} from './validations/bank_statements';

export const powerSoldToSingleUserCondition = (
  singleOrMultipleUsers: Application['system_power_single_or_multiple_users']
) => {
  return singleOrMultipleUsers === 'Single User';
};

export const powerIsCommunitySolarCondition = (
  singleOrMultipleUsers: Application['system_power_single_or_multiple_users'],
  communityOrPPALease: Application['community_solar_or_ppa_lease']
) => {
  return (
    singleOrMultipleUsers === 'Multiple Users' &&
    communityOrPPALease === 'Community Solar Arrangement'
  );
};

const schemaBuilder = (acc, validation) => {
  acc[validation.name] = validation.buildSchema();
  return acc;
};

export const bankStatementsValidation = [
  BankStatementsLastMonthValidation,
  BankStatements2MonthValidation,
  BankStatements3MonthValidation,
].reduce(schemaBuilder, {});

export const companyDocumentsValidation = [
  NonProfitBoardResolutionValidation,
  ReligiousOrganizationAttendanceValidation,
  NonProfitBylawsCopyValidation,
  PropertyCompanyUploadRentRollOrProvideTenantInfoValidation,
  PropertyCompanyRentRollValidation,
  PropertyCompanyTenantNameValidation,
  PropertyCompanyTenantMoveInYearValidation,
  PropertyCompanyTenantMonthlyRentPaymentValidation,
  PropertyCompanyTenantRenewalYearValidation,
  PropertyCompanyTenantRenewalLengthValidation,
  PropertyCompanyTenantPaymentsSatisfactoryValidation,
  PgMortgageStatementValidation,
].reduce(schemaBuilder, {});

export const hoaDocumentsValidation = [
  PriorYearBudgetsValidation,
  CurrentOccupantLedgerValidation,
  MeetingMinutesValidation,
  ReserveStudyValidation,
  DelinquencyReportValidation,
].reduce(schemaBuilder, {});

export const solarSystemDocumentsValidation = [
  LeaseOfTheSystemPropertyValidation,
  // Single User
  OfftakerPPAorLeaseAgreementValidation,
  ProofOfOfftakerCreditworthinessValidation,
  OffTakerLeaseOrProofOfOwnershipValidation,
  OffTakerUtilityBillValidation,
  PpaLeaseFinancialProjectionsValidation,
  // Community Solar
  ApprovalForCommunitySolarDeliveryValidation,
  CommunitySolarFinancialProjectionsValidation,
  SubscriberManagementCompanyContractValidation,
  PrincipalsValidation,
  // PROP-TNT-REL-CHK
  SystemPropertyHasRelatedTenantsValidation,
  // PROP-TNT-REL-CG
  PropertyTenantWillingToBeCommercialGuarantorValidation,
  TaxReturnForLeasingPropCoValidation,
].reduce(schemaBuilder, {});

export const additionalDocumentationValidation = [
  AdditionalDocumentsValidation,
].reduce(schemaBuilder, {});
